import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatosFechas } from '../../../../models/datos-Fechas';
import { ConfigDataService } from '../../../../services/config-data.service';
import { PersonalService } from '../../../../services/personal.service';
import {MyValidations} from '../../../../utils/my-validations';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-datos-fechas-detalle',
  templateUrl: './datos-fechas-detalle.component.html',
  styleUrls: ['./datos-fechas-detalle.component.css']
})
export class DatosFechasDetalleComponent implements OnInit, AfterViewInit {
  
  constructor(private fb: FormBuilder, 
              private configDataSrv: ConfigDataService,
              private personalService: PersonalService) { }

  @Input() set datoFecha(datosFechasRecibida: DatosFechas)
  {
    this.datosFechasForm = datosFechasRecibida;
    this.setearForm(datosFechasRecibida);
  }

  @Input() set enabledForm(condition: boolean)
  {
    this.habilitarForm(condition);
  }

  @Input() MensajeError: string;
  @Input() verDetalle: boolean;
  @Input() disabledEditing: boolean;
  @Input() desdeAnterior: boolean;
  @Input() ingreso: any;
  @Input() anteriorRetroactividad: boolean;
  @Input() grupoLiq: any;
  @Input() datosFechasInvalida: boolean;

  form: FormGroup;
  datosFechasForm: DatosFechas;
  submitted: boolean;
  formHabilitado: boolean;
  clasesFechaList: any;
  MensajeRetro = "";

  ngOnInit(): void
  {
    this.configDataSrv.getDatosFechas()
      .subscribe(
        data => {
          this.clasesFechaList=data;
        },
        error => {
          console.log(error);
        });

    this.configurarValidadores();
    this.setearForm(this.datosFechasForm);
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      personal: ['', Validators.required],
      desde: ['', Validators.required],
      hasta: ['', [Validators.required, MyValidations.fecHastaMenor]],
      claseFecha: ['', Validators.required],
      fechaEvento: ['', Validators.required]
    });
  }

  get registerFormControl()
  {
    return this.form.controls;
  }

  setearForm(datosFechas: DatosFechas)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(datosFechas?.id);
      this.form.controls['desde'].setValue(new Date(datosFechas?.desde));
      this.form.controls['hasta'].setValue(new Date(datosFechas?.hasta));
      this.form.controls['personal'].setValue(datosFechas?.personal);
      this.form.controls['claseFecha'].setValue(datosFechas?.claseFecha);
      if (datosFechas?.fechaEvento != null) {
        this.form.controls['fechaEvento'].setValue(new Date(datosFechas?.fechaEvento));
      }
      
      if (datosFechas.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }
      this.chequeoRetro();
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }
      this.formHabilitado = habilitado;
    }
  }

  ngAfterViewInit()
  {
  }

  setValidatorRequired(campo, requerido) {
    this.form.controls[campo].setValidators(requerido);
    this.form.controls[campo].updateValueAndValidity();
  }

  onChangeFechas()
  {
    this.chequeoRetro();
  }

  chequeoRetro()
  {
    this.MensajeRetro = "";
    let desde = this.form.get("desde").value.toDateString();
    let hasta = this.form.get("hasta").value.toDateString();
    
    this.personalService.ChequeoRetroactividad(this.datosFechasForm.personal, 'DatosFechas', desde, hasta, true).subscribe(
      data =>
      {
        let resul = data;
        if (resul.haceRetro)
        {
          let fecha = formatDate(resul.fechaRetro, 'dd-MM-yyyy', 'en-US');
          this.MensajeRetro = "Esta acción generará Retro a partir del " + fecha.toString();
        }
      }
    );
  }
  
}

